import axiosInstance from '../axios/axios-instance';
import { getAyetClientHintsHeaders } from '../client-hints/client-hints-context';
import { DealTileResponseDto } from 'shared/interfaces/deal/deal-tile-response.dto';
import { GameTileResponseDto } from 'shared/interfaces/game/game-tile-response.dto';
import { INVITE_NOTIFICATIONS_UPDATED_EVENT } from 'src/constants/invite-notifications';

export interface FetchPrioritizedGamesParams {
  /** Filter by games.os_type_id (1 = iOS, 2 = Android, 3 = Web). */
  osTypeId?: number;
  /** Identifies the page so the homepage-only game limit is not applied to Games. */
  surface?: 'homepage' | 'games_page';
}

export const gameRecommendationEngine = {
  /**
   * Fetches prioritized games for the current user.
   * @returns Array of signed game tile DTOs representing the prioritized games
   */
  async fetchPrioritizedGames(params?: FetchPrioritizedGamesParams): Promise<GameTileResponseDto[]> {
    const headers = await getAyetClientHintsHeaders();
    const response = await axiosInstance.get<GameTileResponseDto[]>('/game-recommendation-engine/prioritized-games', {
      headers,
      params:
        params?.osTypeId != null || params?.surface != null
          ? { os_type_id: params.osTypeId, surface: params.surface }
          : undefined,
    });
    window.dispatchEvent(new Event(INVITE_NOTIFICATIONS_UPDATED_EVENT));
    return response.data;
  },

  async fetchPrioritizedDeals(params?: FetchPrioritizedGamesParams): Promise<DealTileResponseDto[]> {
    const headers = await getAyetClientHintsHeaders();
    const response = await axiosInstance.get<DealTileResponseDto[]>('/game-recommendation-engine/prioritized-deals', {
      headers,
      params: params?.osTypeId != null ? { os_type_id: params.osTypeId } : undefined,
    });
    return response.data;
  },
};
